function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CloseIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M13.3995 11.9853L20.4706 19.0563L19.0563 20.4706L11.9853 13.3995L4.91423 20.4706L3.50001 19.0563L10.5711 11.9853L3.5 4.91421L4.91421 3.5L11.9853 10.5711L19.0564 3.5L20.4706 4.91421L13.3995 11.9853Z",
    fill: "currentColor"
  }));
}
export function CloseIconSmall(props) {
  return ___EmotionJSX(CloseIcon, _extends({
    size: "small"
  }, props));
}